import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import './Report.scss';

import { connect } from 'react-redux';
import { gsap } from 'gsap';

import * as actionCreators from '../../store/actions/index';

import jsonData from './report.json';
import ResultsSpider from '../../components/Spider/ResultsSpider';
import CTAs from '../../components/CTAs/CTAs';
import Frame from '../../components/Frame/Frame';



//animationsx
let total = 0;
let TotalScore = 0;



const Report = props => {

    $('html').addClass('show');
    const scores = props.scrs;
    let loc=`http://${window.location.host}${window.location.pathname}?report=true&score=${props.prms.get('score')}&role=${props.prms.get('role')}`
    const hostURL = window.location.host;
    const pathURL = window.location.pathname;
    const searchURL = window.location.search;

   
    const ANSWERS_MAP = {
        25: 0,
        50: 33,
        75: 66,
        100: 100,
    };

    useEffect(() => {
        props.onChooseQuestions(props.rol, 'English');
        props.onInitScores(scores);

        if (window.location.href.indexOf("gateoff=true") > -1) {
            $('iframe').hide();
            $('.report').removeClass('blur');
          }

        function updateSummary() {
            $("#executive-summary").html("");
            let summary_content = '';
            var summary_level = jsonData.summary[0].low;
            if (TotalScore > 26) {
                summary_level = jsonData.summary[0].med;
                if (TotalScore > 51) {
                    summary_level = jsonData.summary[0]['med-high'];
                    if (TotalScore > 76) {
                        summary_level = jsonData.summary[0].high
                    }
                }

            }
            $.each(summary_level, function (index, value) {
                summary_content += value;
            });

            $("#executive-summary").append(summary_content);
            //document.getElementById("field21").value = loc;
            localStorage.setItem('userURL',loc)

            $("#social-link-mail").on('click', mailHandler)



        }


        for (var i = 0; i < scores.length; i++) {
            // const ans_temp = ANSWERS_MAP[scores[i]];
            total += Number(scores[i]);
            TotalScore = Math.round(total / scores.length);
            if (i === scores.length - 1) {
                setTimeout(function () {
                    const obj = document.getElementById("user-score");
                    arrangeElements();
                    updateSummary()
                    cloudAnimations();
                    animateNumbers(obj, 0, TotalScore, 1500);
                    $('.dynamic-content-text-0').height($('.dynamic-content-text--1-0').height());

                }, 1000)
            }
        }
    }, []);

    useEffect(() =>{        
        props.onSetCurrentLabel(props.currentLabels[0]);
    },[props.currentLabels])


    window.onresize = arrangeElements;

    function arrangeElements() {
        if (window.innerWidth < 1025) {
            $('.cloud-animation').detach().appendTo(".mobile-cloud-holder");
            $('.report-section-graph').detach().appendTo(".mobile-spider-holder");

        }
        else {
            $('.report-section-graph').detach().appendTo(".report-section-spider .report__content-right");
            $('.cloud-animation').detach().appendTo(".report-section-hero .report__content-right");
        }
    }



    function cloudAnimations() {
        var h = 209;
        if (window.innerWidth < 1024) {
            h = 120.3
        }
        let backgroundHeight = (TotalScore / 100) * h;
        $("#cloud-anim-background").css("height", TotalScore + "%");
        $("#numbers-holder").css("bottom", backgroundHeight + "px");
    }

    function mailHandler(){
        let email= localStorage.getItem('email');
        let link=encodeURIComponent(loc)+"%26gateoff=true"
        window.open("mailto:"+email+"?subject=PLM%20maturity%20assessment%20results&body=My%20report%20from%20PLM%20maturity%20assessment%20(oracle.com%2Fgoto%2Fplm-assessment):%20" + link,"_blank")
    }

    function animateNumbers(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    const spiderLabelClickHandlr = (lablName) => {  
        props.onSetCurrentLabel(lablName);

        const changeLabel = () => {
            $('.dynamic-content-label-0').text(lablName);
        }

        const checkHeight = () => {

            $('.dynamic-content-text-0').height($('.dynamic-content-text--1-0').height());
        }

        const changeText = () => {
            $('.dynamic-content-text--1-0').text(jsonData.capabilitiesx[lablName.toLowerCase()]);
        }

        gsap.to(`.dynamic-content-label-0`, {
            opacity: 0,
            x: 10,
            duration: .5,
            onComplete: changeLabel,
        })


        gsap.to(`.dynamic-content-text--1-0`, {
            opacity: 0,
            x: 10,
            duration: .5,
            onComplete: changeText
        })



        gsap.to(`.dynamic-content-label-0`, {
            x: 0,
            opacity: 1,
            duration: .5,
        })
            .delay(.75);

        gsap.to(`.dynamic-content-text--1-0`, {
            x: 0,
            opacity: 1,
            duration: .5,
            onStart: checkHeight
        })
            .delay(.75);

    };

    const dynamixTxtContentCap = () => {        
        const retThis0 = [
            <React.Fragment>
                <div className={`dynamic-content-label dynamic-content-label-${0}`} id="dynamic-label" key={`d1-${0}`}>{props.currentLabels[0]}</div>
                <div className={`dynamic-content-text dynamic-content-text-${0}`} key={`d2-${0}`}>
                    <p className={`dynamic-content-text--1 dynamic-content-text--1-${0}`} key={`d3-${0}`}>
                        {jsonData.capabilitiesx[props.currentLabels[0].toLowerCase()]}
                    </p>
                    <div className=""></div>
                    <CTAs
                        currLblsMob={props.currentLabels[0]}
                    />
                </div>                
                <div className="dynamic-content-hr dynamic-content-hr-0" key={`d4-${0}`}></div>
            </React.Fragment>
        ]

        const retThis1 = props.currentLabels.map((e, i) => {
            return (
                <React.Fragment>
                    <div className={`dynamic-content-label dynamic-content-label-${i + 1}`} id="dynamic-label" key={`d1-${i + 1}`}>{props.currentLabels[i]}</div>
                    <div className={`dynamic-content-text dynamic-content-text-${i + 1}`} key={`d2-${i + 1}`}>
                        <p className={`dynamic-content-text--1 dynamic-content-text--1-${i + 1}`} key={`d3-${i + 1}`}>{jsonData.capabilitiesx[props.currentLabels[i].toLowerCase()]}</p>
                        <CTAs
                            currLblsMob={props.currentLabels[i]}
                        />
                    </div>
                    <div className={`dynamic-content-hr dynamic-content-hr-${i + 1}`} key={`d4-${i + 1}`}></div>
                </React.Fragment>
            );
        });

        return retThis0.concat(retThis1);
    }


    return (

        <div className="report-holder">
            <Frame></Frame>

        <div className="report blur">
            <section className="report-section report-section-hero">
                <div className="report__content ">
                    <div className="report__content-left">
                        <div className="report-section-hero-logo"></div>
                        <h3>Results report for {props.rol}</h3>
                        <h1 className="Landing__title">The path to fully connected product lifecycle</h1>
                        <h2>Executive summary</h2>
                        <div className="mobile-cloud-holder"></div>
                        <div id="executive-summary"></div>
                    </div>
                    <div className="report__content-right relative">
                        <div className="cloud-animation">
                            <div className="cloud-animation-numbers" id="numbers-holder">
                                <div className="cloud-animation-number" id="user-score">
                                </div>
                                <div className="cloud-animation-number" >/100</div>

                            </div>
                            <div className="cloud-animation-image-2" id="cloud-anim-background"></div>
                            <div className="cloud-animation-image-1"></div>
                            <div className="cloud-animation-label">Overall PLM maturity score</div>

                        </div>
                    </div>
                </div>
            </section>
            <section className="report-section report-section-spider">
                <div className="report__content">
                    <div className="report__content-left">
                        <div className="report-section-header">Resources and capabilities</div>
                        <div className="mobile-spider-holder"></div>
                        <div className="dynamic-content">
                            {dynamixTxtContentCap()}
                            <CTAs/>
                        </div>

                    </div>
                    <div className="report__content-right">
                        <div className="report-section-graph">
                            {/* TODO - add spider class here */}
                            <ResultsSpider
                                spdrlblclick={spiderLabelClickHandlr}
                            />
                        </div>


                    </div>
                </div>
            </section>
            <section className="report-section report-section-summary">
                <div className="report__content">
                    <div className="report__content-left">
                        <div className="report-section-header">Summary and next steps</div>
                        <div className="report-section-summary-content">
                            <p>Through consistent focus, your company can reap the benefit of adopting leading product innovation practices. </p>
                            <p>Adopting a structured and connected approach with a holistic view on the full product lifecycle throughout the supply chain is an essential step on the path to innovation excellence. Using a common platform with single point of truth for products, documents, engineering change orders, and qualify workflows, you can streamline innovation processes with internal cross-functional teams and external partners. Make better decisions on innovation investment mix and resource allocation by evaluating product pipeline with data and best-practice analysis.</p>
                            <p>For information on Oracle Fusion Cloud Product Lifecycle Management (PLM), visit<br /><a href="https://www.oracle.com/scm/product-lifecycle-management/" target="_blank">https://www.oracle.com/scm/product-lifecycle-management/</a>.</p>
                        </div>
                        <div className="social-links">
                            <div className="social-links-header">Email the link to the report</div>
                            <a className="social-link social-link-mail" id="social-link-mail" target="_blank"></a>
                        </div>
                    </div>
                    <div className="report__content-right">
                        <div className="next-steps">
                            <div className="next-step next-step-top next-step-left">
                                <div className="next-step-icon next-step-icon-demo"></div>
                                <div className="next-step-label">Request a demo</div>
                                <div className="next-step-text">See what Oracle Fusion Cloud SCM can do for you.</div>
                                <a className="next-step-btn" href="https://go.oracle.com/LP=43622?qt=saas_scm_fam&src1=:ow:o:h:feb:::SCMOCOM&intcmp=WWMK170227P00050:ow:o:h:feb:::SCMOCOM
" target="_blank">Request a Demo</a>



                            </div>
                            <div className="next-step next-step-top ">
                                <div className="next-step-icon next-step-icon-tour"></div>
                                <div className="next-step-label">Take a tour</div>
                                <div className="next-step-text">Explore Oracle Fusion Cloud SCM applications.</div>
                                <a className="next-step-btn" href="https://www.oracle.com/scm/product-tours/" target="_blank">Browse tours</a>
                            </div>
                            <div className="next-step next-step-left">
                                <div className="next-step-icon next-step-icon-contact"></div>
                                <div className="next-step-label">Contact us</div>
                                <div className="next-step-text width-110">Talk to a team member about Oracle Fusion Cloud SCM.</div>
                                <a className="next-step-btn" href="https://www.oracle.com/applications/supply-chain-management/contact-form.html
" target="_blank">Contact us</a>
                            </div>

                            <div className="next-step ">
                                <div className="next-step-icon next-step-icon-learn"></div>
                                <div className="next-step-label">Learn more</div>
                                <div className="next-step-text">Learn what Oracle Fusion Cloud PLM can do for you.</div>
                                <a className="next-step-btn copy-btn" href="https://www.oracle.com/scm/product-lifecycle-management/" target="_blank" >Learn more</a>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <section className="report-section report-section-footer">
                <div className="report__content">
                    <div className="report-section-footer-content">
                        <a target="_blank" rel="noreferrer" href="https://www.oracle.com/legal/privacy/" className="report-section-footer-link">© 2021 Oracle</a><span className="Footer__line"></span>
                        <a target="_blank" rel="noreferrer" href="https://www.oracle.com/legal/privacy/" className="report-section-footer-link">Privacy/Do Not Sell My Info</a>
                        <a target="_blank" rel="noreferrer" id="teconsent" className="report-section-footer-link">Cookie Preference</a>
                        <a target="_blank" rel="noreferrer" href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising" className="report-section-footer-link last-link">Ad Choices</a>
                    </div>

                    <div className="o-tag"></div>
                </div>
            </section>
        </div>
    </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onChooseQuestions: (role, lang) => dispatch(actionCreators.choose_questions(role, lang)),
        onInitScores: (scrz) => dispatch(actionCreators.init_scores(scrz)),
        onSetCurrentLabel: (lbl) => dispatch(actionCreators.set_label(lbl)), 
    };
};

const mapStateToProps = state => {
    return {
        currentLabels: state.questionsReducer.currentLabels,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Report);